import { inject, PLATFORM_ID } from '@angular/core';
import { ActivatedRouteSnapshot, DetachedRouteHandle, RouteReuseStrategy } from '@angular/router';
import { StorageService } from '../services/storage.service';
import { isPlatformBrowser } from '@angular/common';

export class CustomRouteReuseStrategy implements RouteReuseStrategy {
    private currentLanguage = '';
    private storageService = inject(StorageService);
    private platformId = inject(PLATFORM_ID);
    private isBrowser = isPlatformBrowser(this.platformId);

    constructor() {
        if (this.isBrowser) {
            this.currentLanguage = this.storageService.language;
        }
    }

    shouldDetach(): boolean {
        return false;
    }

    store(): void {}

    shouldAttach(): boolean {
        return false;
    }

    retrieve(): DetachedRouteHandle | null {
        return null;
    }

    shouldReuseRoute(future: ActivatedRouteSnapshot, curr: ActivatedRouteSnapshot): boolean {
        let isReload = false;

        if (this.isBrowser) {
            const futureLanguage = this.storageService.language;

            if (futureLanguage !== this.currentLanguage) {
                this.currentLanguage = futureLanguage;

                isReload = true;
            }
        }

        if (isReload) {
            return false;
        }

        return future.routeConfig === curr.routeConfig;
    }
}
